// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"76":"common","480":"special","527":"shopping","709":"order"}[chunkId] || chunkId) + "." + {"76":"47a91f54","480":"5529ea5c","527":"61a28632","709":"bb97babb","927":"ce42fa29"}[chunkId] + ".css";
};